import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email, name: "" });
      toast.success("Subscribed.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-4 max-w-xl" data-testid="newsletter-form">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email"
        className="input-bare flex-1"
        data-testid="newsletter-email-input"
      />
      <button type="submit" disabled={loading} className="btn-primary" data-testid="newsletter-submit-btn">
        {loading ? "..." : "Subscribe"}
      </button>
    </form>
  );
};

export default Newsletter;
